import { STEP_DATA } from "../../constants/trade-in-your-car-constants";

export  default (step, c2bEligible) => {
    const { heading, description, lastStep, screenLoadGa } = STEP_DATA[step];
    let  { ctaText, gaKey }  = STEP_DATA[step];
    if (step === STEP_DATA.VALUATION.step  &&  !c2bEligible) {
        ctaText = "Proceed to trade-in";
        gaKey = "proceed_to_trade_in";
    }

    return { heading, description, ctaText, lastStep, gaKey, screenLoadGa};
};
